import { render, staticRenderFns } from "./DatosGeneralesEvaluadoSection.vue?vue&type=template&id=205e893f"
import script from "./DatosGeneralesEvaluadoSection.vue?vue&type=script&lang=js"
export * from "./DatosGeneralesEvaluadoSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports